//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
// 
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
// 
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import { compose }              from 'redux';
import { createStore }          from 'redux';
import { applyMiddleware }      from 'redux';
import rootReducer              from './reducer';
import createSagaMiddleware     from 'redux-saga';
import { createBrowserHistory } from 'history';
import { routerMiddleware }     from 'connected-react-router';
import withReady                from 'redux-ready';
import sagas                    from './sagas/index';
import { persistStore }         from 'redux-persist';
import { persistReducer }       from 'redux-persist';
import storage                  from 'redux-persist/lib/storage';
import Environment              from '../helper/Environment';
import _                        from 'lodash';
import apiMiddleware            from './miscellaneous/api';

export const history        = createBrowserHistory();
export const sagaMiddleware = createSagaMiddleware();

const apiMiddlewareService = apiMiddleware();

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

export default initialState => {
    const isDevelopment    = Environment.isDevelopment();
    const allMiddlewares   = [
        (
            isDevelopment ?
                require('redux-immutable-state-invariant').default() :
                null
        ),
        apiMiddlewareService,
        sagaMiddleware,
        routerMiddleware(history),
    ];
    const middlewares      = _.reject(allMiddlewares, _.isNull);
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
    const store            = createStore(
        persistedReducer,
        initialState,
        composeEnhancers(
            withReady,
            applyMiddleware(...middlewares),
        ),
    );

    store.ready().then(state => {
        sagaMiddleware.run(sagas.root);
    });

    let persistor = persistStore(store);

    return store;
};
